export default __webpack_public_path__ + "static/media/Mark-4-Suit-00.79970395.jpg";